import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-expiration-date-duration-days-null",
  // imports: [],
  templateUrl: "./expiration-date-duration-days-null.component.html",
  styleUrl: "./expiration-date-duration-days-null.component.css",
  standalone: false,
})
export class ExpirationDateDurationDaysNullComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
